export const RESET_APPS = "RESET_APPS";

// Shared functionality to reset all apps
function resetApps() {
  return {
    type: RESET_APPS
  };
}

export { resetApps };



// WEBPACK FOOTER //
// ./src/store/actions.js